const parseNumeric = (value?: number | string): number => {
  if (typeof value === 'string' && value.trim() === '') return NaN;
  return Number(value);
};

/**
 * Inserts the teaser card into one page of listing cards (#1709).
 * The 1-based position is clamped: values beyond the page length (e.g. 999)
 * append the card at the end. Applied per page, so the card repeats at the
 * same position on every pagination page. The position arrives as a string
 * when edited through the number widget.
 */
export const insertTeaserCard = <T>(
  items: T[],
  teaserCard: T,
  position?: number | string,
): T[] => {
  const parsed = parseNumeric(position);
  const requested = Number.isFinite(parsed) ? Math.round(parsed) : 999;
  const index = Math.min(Math.max(requested, 1) - 1, items.length);
  return [...items.slice(0, index), teaserCard, ...items.slice(index)];
};

/**
 * The teaser card counts towards the page size (#1709): with the card
 * enabled, one result less is requested per page so the card displaces a
 * result to the next page instead of enlarging the page. A page size of 0
 * (unbatched) or 1 is left untouched.
 */
export const teaserPageSize = (
  pageSize: number | string | undefined,
  showTeaserCard: boolean | undefined,
  fallback: number,
): number => {
  const parsed = parseNumeric(pageSize);
  const base = Number.isFinite(parsed) ? parsed : fallback;
  return showTeaserCard && base > 1 ? base - 1 : base;
};

export const FILTERED_PAGE_SIZE = 16;

export const listingPageSize = (
  pageSize: number | string | undefined,
  showTeaserCard: boolean | undefined,
  activateFilter: boolean | undefined,
  defaultPageSize: number,
): number | undefined => {
  if (activateFilter) {
    return teaserPageSize(
      pageSize || FILTERED_PAGE_SIZE,
      showTeaserCard,
      FILTERED_PAGE_SIZE,
    );
  }
  return showTeaserCard
    ? teaserPageSize(pageSize, true, defaultPageSize)
    : undefined;
};
